<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-pen.png" alt width="27.3" height="27.3" />
      <p class="title-bk">コース編集</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'course-id-detail', params: { id } }">戻る</router-link>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <a href="/pdf/form_course.pdf" target="_blank">フォームの説明を確認</a>
    </div>
    <div class="container">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(confirmEdited)" ref="form">
          <table class="table table-form">
            <tbody>
              <tr>
                <th scope="row">法人名（法人ID）</th>
                <td />
                <td>{{ currentCorporationDisplay }}</td>
              </tr>
              <tr>
                <th scope="row">ブランド名（ブランドID）</th>
                <td />
                <td>{{ currentBrandDisplay }}</td>
              </tr>
              <TextField
                v-model="currentCourse.name"
                extraRules="required"
                label="コース名"
                placeholder="入力してください"
              />
              <TextField
                v-model="currentCourse.nameReading"
                extraRules="required"
                label="コース名フリガナ"
                placeholder="入力してください"
              />
              <tr>
                <th scope="row">コースID（自動生成）</th>
                <td />
                <td>{{ currentCourse.uid }}</td>
              </tr>
              <SelectField
                label="確認テスト合格点数"
                extraRules="required_select"
                inputClass="col-lg-3"
                placeholder="選択してください"
                :options="testPassingScoreOptions"
                v-model="currentCourse.testPassingScore"
              />
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-confirm">確認</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import store from '@/store/index.js';
import { ValidationObserver } from 'vee-validate';
import TextField from '@/components/forms/TextField.vue';
import SelectField from '@/components/forms/SelectField.vue';
import { basicCorporationNameIdPresent, basicBrandNameIdPresent } from '@/presenters/fields';

export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {};
  },
  components: {
    ValidationObserver,
    TextField,
    SelectField,
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('course/fetchCourse', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  computed: {
    currentCourse() {
      if (this.course.editingCourse) {
        return this.course.editingCourse;
      } else {
        return this.course.course;
      }
    },
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.currentCourse.corporation);
    },
    currentBrandDisplay() {
      return basicBrandNameIdPresent(this.currentCourse.brand);
    },
    ...mapState(['course']),
    ...mapGetters('course', ['testPassingScoreOptions']),
  },
  methods: {
    confirmEdited() {
      this.$logger.debug('Started Editing: ' + JSON.stringify(this.currentCourse));
      this.startEditingCourse(this.currentCourse);
      this.$router.push({ name: 'course-id-confirm', params: { id: this.id } });
    },
    ...mapActions('course', ['startEditingCourse']),
  },
};
</script>

<style scoped>
.btn-confirm {
  margin-left: 0px;
}
</style>
